// CORE
import React from "react";
import { Link } from "react-router-dom";
// ASSETS
import sloganImage from "./assets/images/slogan.png";
import { ReactComponent as BurgerIcon } from "./assets/svg/burger.svg";
// STYLE
import styles from "./styles/style.module.scss";
// COMPONENTS
import Notifications from "./Notifications";
import UserControl from "./UserControl";
import LanguageControl from "./LanguageControl";
import ThemeSwitcher from "./ThemeSwitcher";

const Header = ({
    sidebarCollapsed,
    setSidebarCollapsed,
    setOffcanvasShow,
}) => {
    // SIDEBAR TOGGLE FUNCTION
    const sidebarToggle = () => {
        setSidebarCollapsed((prev) => !prev);
    };

    return (
        <div className={`${styles["main-head"]}`}>
            <div className={`wrapper ${sidebarCollapsed ? "collapsed" : ""}`}>
                <div className="head-wrp">
                    <div className="">
                        {/* DESKTOP MENU BUTTON */}
                        <div className="burgerBtn desktop">
                            <button
                                className="toggleSidebar"
                                onClick={() => sidebarToggle()}
                            >
                                <BurgerIcon />
                            </button>
                        </div>
                        {/* MOBILE MENU BUTTON */}
                        <div className="burgerBtn mobile">
                            <button
                                className="toggleSidebar"
                                onClick={() => setOffcanvasShow(true)}
                            >
                                <BurgerIcon />
                            </button>
                        </div>
                    </div>
                    {/* LOGO */}
                    <div className="image-container">
                        <Link to="/">
                            <img src={sloganImage} alt="" />
                        </Link>
                    </div>
                    {/* HEADER ACTIONS */}
                    <div className="header-actions">
                        {/* NOTIFICATIONS */}
                        <div className="notifications-control">
                            <Notifications />
                        </div>
                        {/* THEME SWITCH */}
                        <div className="theme-switch">
                            <ThemeSwitcher />
                        </div>
                        {/* LANGUAGE CONTROL */}
                        <div className="language-switch">
                            <LanguageControl />
                        </div>
                        {/* USER CONTROL */}
                        <div className="user-control">
                            <UserControl />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;
